// A COMPLETED visit stays editable for this many days after it ends; once the
// window passes the visit becomes read-only on both the professional modal and
// the guest page. Mirror of the backend helper of the same name.
export const VISIT_EDIT_WINDOW_DAYS = 30;

const COMPLETED_STATUS = 'COMPLETED';

/**
 * Whether a visit's edit window is still open.
 *
 * Only COMPLETED visits are time-gated — they remain editable until
 * VISIT_EDIT_WINDOW_DAYS days after `endTime`. Any other status returns true
 * (the window does not apply; status-based rules govern instead). A missing or
 * unparseable `endTime` fails open so we never lock the user out of valid data.
 */
export function isVisitEditWindowOpen(
  status?: string | null,
  endTime?: string | Date | null,
  windowDays: number = VISIT_EDIT_WINDOW_DAYS,
): boolean {
  if (status !== COMPLETED_STATUS) return true;
  if (!endTime) return true;
  const end = new Date(endTime);
  if (Number.isNaN(end.getTime())) return true;
  const cutoff = new Date(end);
  cutoff.setDate(cutoff.getDate() + windowDays);
  return new Date() <= cutoff;
}

export default isVisitEditWindowOpen;
